/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import { logout } from "../../network/ApiAxios";

// reactstrap components
import {Collapse,DropdownMenu,DropdownItem,UncontrolledDropdown,DropdownToggle,Media,NavbarBrand,Navbar,NavItem,NavLink,Nav,Container,Row,Col,} from "reactstrap";
import CheckPermission from "variables/CheckPermission";

var ps;
const ReSellerSidebar =(props)=>{
  const [collapseOpen, setcollapseOpen] = useState(false);
  
  const toggleCollapse = () => { setcollapseOpen(!collapseOpen)} // toggles collapse between opened and closed (true/false)
  const closeCollapse = () => { setcollapseOpen(false)} // closes the collapse

  const user = JSON.parse(localStorage.getItem("user"));
  let role = JSON.parse(localStorage.getItem("user")).role;

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
      navbarBrandProps = {
        to: logo.innerLink,
        tag: Link,
      };
  } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        href: logo.outterLink,
        target: "_blank",
      };
  }

  const getLinks = (links)=>{
    return links.map((link=>{
      return(<NavItem key={link.link}>
        <NavLink
          to={link.link}
          tag={NavLinkRRD}
          onClick={closeCollapse}
          activeClassName="active"
        >        
          <i className={link.icon + " " + link.iconColor} />
          {link.text}
        </NavLink>
      </NavItem>)
    }))
    
}

const logOut = async () => {
  const token = localStorage.getItem("token");
  if (token) {
    const response = await logout(token);
    const { data } = response;
    if (data.success) {
      localStorage.clear();
      history.push("/auth/login");
    }
  }
};

  const normalLinks = [
    {link:"/reseller/index",text:"Dashboard",icon:"ni ni-tv-2",iconColor:"text-primary"},
    {link:"/reseller/profile",text:"User Profile",icon:"ni ni-single-02",iconColor:"text-yellow"},
    {link:"/reseller/events",text:"Events",icon:"ni ni-single-02",iconColor:"text-black"},
    {link:"/reseller/orders",text:"Past Orders",icon:"ni ni-single-02",iconColor:"text-blue"},
  ]
  const adminLinks = [
  ]

  return(
    <Navbar
        className="navbar-vertical fixed-left navbar-light bg-white"
        expand="md"
        id="sidenav-main"
      >
        {/*<CheckPermission/>*/}
        <Container fluid>
          {/* Toggler */}
          <button
            className="navbar-toggler float-left"
            type="button"
            onClick={toggleCollapse}
          >
            <span className="navbar-toggler-icon" />
          </button>
          {/* Brand */}
          {logo ? (
            <NavbarBrand className="pt-0" {...navbarBrandProps}>
              <img
                alt={logo.imgAlt}
                className="navbar-brand-img"
                src={logo.imgSrc}
              />
            </NavbarBrand>
          ) : null}
          {/* User */}
          <Nav className="align-items-center float-right d-md-none">
            <UncontrolledDropdown nav>
              <DropdownToggle nav className="nav-link-icon">
                <i className="ni ni-bell-55" />
              </DropdownToggle>
              <DropdownMenu
                aria-labelledby="navbar-default_dropdown_1"
                className="dropdown-menu-arrow"
                right
              >
                <DropdownItem>Action</DropdownItem>
                <DropdownItem>Another action</DropdownItem>
                <DropdownItem divider />
                <DropdownItem>Something else here</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <UncontrolledDropdown nav>
              <DropdownToggle nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <img alt="..." src={user.test} />
                  </span>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                <DropdownItem to={"/" + role + "/user-profile"} tag={Link}>
                  <i className="ni ni-single-02" />
                  <span>My profile</span>
                </DropdownItem>
                <DropdownItem to={"/" + role + "/newpass"} tag={Link}>
                  <i className="ni ni-key-25" />
                  <span>Change Password</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link} hidden>
                  <i className="ni ni-settings-gear-65" />
                  <span>Settings</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link} hidden>
                  <i className="ni ni-calendar-grid-58" />
                  <span>Activity</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link} hidden>
                  <i className="ni ni-support-16" />
                  <span>Support</span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="#pablo" onClick={logOut}>
                  <i className="ni ni-user-run" />
                  <span>Logout</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
          {/* Collapse */}
          <Collapse navbar isOpen={collapseOpen}>
            {/* Collapse header */}
            <div className="navbar-collapse-header d-md-none">
              <Row>
                {logo ? (
                  <Col className="collapse-brand" xs="6">
                    {logo.innerLink ? (
                      <Link to={logo.innerLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </Link>
                    ) : (
                      <a href={logo.outterLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </a>
                    )}
                  </Col>
                ) : null}
                <Col className="collapse-close" xs="6">
                  <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleCollapse}
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            {/* Navigation */}
            <Nav navbar>{/*Normal LINKS GO HERE */}
            
                {getLinks(normalLinks)}
            
            </Nav>
            {/* Divider 
            <hr className="my-3" />
            <h6 className="navbar-heading text-muted">ADMIN</h6>
            */}
            {/* API links */}
            {/*<Nav navbar>Admin LINKS GO HERE 
            
                 {getLinks(adminLinks)}
            
            </Nav>*/}
          </Collapse>
        </Container>

      </Navbar>
  )
}


ReSellerSidebar.defaultProps = {
  routes: [{}],
};

ReSellerSidebar.propTypes = {
  // links that will be displayed inside the component
  //routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default ReSellerSidebar;
